import classNames from 'clsx';
import React from 'react';
import { Hint } from 'reactApp/ui/Hint/Hint';
import type { TSpaceInfo } from 'reactApp/ui/Space/SingleSpace/SingleSpaceProgress/SingleSpaceProgress.types';
import { noopVoid } from 'reactApp/utils/helpers';

import styles from './SingleSpaceProgress.css';

export const SingleSpaceProgressBar = ({
    spaceList,
    height,
    isOverquota,
    freeSpaceText,
    usedPercents,
    isSubscriprionRebranding,
    redWhenOverquota,
    rebranding,
}: {
    spaceList: TSpaceInfo[];
    height?: number;
    isOverquota: boolean;
    freeSpaceText: string;
    usedPercents: number;
    isSubscriprionRebranding?: boolean;
    redWhenOverquota?: boolean;
    rebranding?: boolean;
}) => {
    let zeroSpace = false;
    return (
        <div
            className={classNames(styles.line, {
                [styles.line_overquota]: isOverquota,
                [styles.line_twoOverquota]: isOverquota && redWhenOverquota,
                [styles.rebranding]: rebranding,
                [styles.line_subscriprion_rebranding]: isSubscriprionRebranding,
                [styles[`height_${height}`]]: height,
            })}
        >
            <div style={{ width: `${usedPercents}%` }}>
                {spaceList.map(({ id, percents, isOverquota, hintText, onClick = noopVoid }, key) => {
                    if (percents <= 1) {
                        zeroSpace = true;
                    }
                    if (usedPercents > 100 && !zeroSpace) {
                        percents = (percents * 100) / usedPercents;
                    }
                    return (
                        <Hint text={hintText} key={id}>
                            <div
                                className={classNames(styles.lineFilled, styles[`line_${id}`], {
                                    [styles.lineFilled_overquota]: isOverquota,
                                })}
                                style={{
                                    minWidth: key !== 0 ? '14px' : '',
                                    width: usedPercents === percents && key !== 0 ? `calc(${percents}% + 6px)` : `${percents}%`,
                                }}
                                onClick={onClick}
                            />
                        </Hint>
                    );
                })}
            </div>
            <Hint text={freeSpaceText}>
                <div className={styles.lineEmpty} />
            </Hint>
        </div>
    );
};
